<template>
  <div class="headerBox" :style="`background-image: url(${banner})`">
    <header
      :class="fixedNav ? 'header header-fixed' : 'header'"
      @mouseleave="mouseleave"
      @mouseover="mouseover"
    >
      <div class="el-row" style="height: 100%">
        <div
          class="height_100 el-col el-col-24 el-col-sm-17 el-col-md-15 el-col-md-offset-1 el-col-lg-12 el-col-lg-offset-3 el-col-xl-8 el-col-xl-offset-4"
        >
          <ul class="header_left clearfix height_100">
            <li class="logo">
              <img
                src="../../assets/newimg/logo.png"
                v-show="isShowBlackLogo"
              />
              <img
                src="../../assets/newimg/logo_w.png"
                v-show="!isShowBlackLogo"
              />
            </li>
            <li>
              <a
                href="/"
                :class="
                  myMenuIndex == 0
                    ? 'router-link-exact-active router-link-active'
                    : ''
                "
                >首页</a
              >
            </li>
            <li style="cursor: pointer">
              <a
                :class="
                  myMenuIndex == 1
                    ? 'router-link-exact-active router-link-active solution-menu'
                    : 'solution-menu'
                "
                >产品</a
              >
              <div class="solution-container">
                <div
                  v-for="(item, index) in productList"
                  :key="index"
                  class="solution-container-item"
                  @click="clickProductItem(item.url)"
                >
                  <div>{{ item.title }}</div>
                  <div>{{ item.content }}</div>
                </div>
              </div>
            </li>
            <li>
              <a
                href="/yantuai"
                :class="
                  myMenuIndex == 2
                    ? 'router-link-exact-active router-link-active'
                    : ''
                "
                >岩土AI</a
              >
            </li>
            <!-- <li style="cursor: pointer">
              <a
                :class="
                  myMenuIndex == 2
                    ? 'router-link-exact-active router-link-active solution-menu'
                    : 'solution-menu'
                "
                >解决方案</a
              >
              <div class="solution-container">
                <div
                  v-for="(item, index) in solutionList"
                  :key="index"
                  class="solution-container-item"
                  @click="clickProductItem(item.url)"
                >
                  <div>{{ item.title }}</div>
                  <div>{{ item.content }}</div>
                </div>
              </div>
            </li> -->

            <li>
              <a
                href="/about"
                :class="
                  myMenuIndex == 4
                    ? 'router-link-exact-active router-link-active'
                    : ''
                "
                >关于我们</a
              >
            </li>
          </ul>
        </div>
      </div>
    </header>
    <header class="hidden-sm-and-up header_warp_m">
      <div class="header_m clearfix" v-bind:class="{ header_m_active }">
        <div class="header_logo">
          <img src="../../assets/newimg/logo.png" alt="" />
          <!---->
        </div>
        <div class="header_icon">
          <div
            class="header_icon_btn"
            v-bind:class="{ header_icon_btn1 }"
            @click="showCont"
          >
            <span></span> <span></span> <span></span>
          </div>
        </div>
      </div>
      <div class="nav_m" v-if="show">
        <div class="nav_m_warp">
          <ul class="nav_m_list">
            <li>
              <a href="/" class="router-link-exact-active router-link-active"
                >首页</a
              >
            </li>
            <li><a href="/openAbility" class="">开放能力</a></li>
            <li><a href="/product" class="">解决方案</a></li>
            <!-- <li><a href="/solve" class="">解决方案</a></li> -->
            <li><a href="/about" class="">关于我们</a></li>
            <li><a href="/Application" class="">申请试用</a></li>
          </ul>
          <div class="nav_m_text">
            <p>来电申请定制化解决方案</p>
            <p class="nav_m_text_b"><span>155 9679 4823</span></p>
          </div>
        </div>
      </div>
      <!---->
    </header>
    <div class="banner">
      <div class="banner_con">
        <p
          :style="
            'color:' +
              mainTitleColor +
              ';top:' +
              mainTitleTop +
              ';left:' +
              mainTitleLeft
          "
        >
          {{ mainTitle }}
        </p>
        <p
          v-if="subTitle"
          :style="
            'color:' +
              subTitleColor +
              ';top:' +
              subTitleTop +
              ';left:' +
              subTitleLeft
          "
        >
          {{ subTitle }}
        </p>
        <p
          v-if="subTitle2"
          :style="
            'color:' +
              subTitle2Color +
              ';top:' +
              subTitle2Top +
              ';left:' +
              subTitle2Left
          "
        >
          {{ subTitle2 }}
        </p>
        <div
          v-if="showBtn"
          @click="$router.push('/application')"
          class="btn"
          :style="'top:' + btnTop + ';left:' + btnLeft"
        >
          <span>在线咨询</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuIndex: {
      type: Number,
      default: 0,
    },
    banner: {
      type: String,
    },
    // 主标题配置
    mainTitle: {
      type: String,
    },
    mainTitleColor: {
      type: String,
      default: "#000",
    },
    mainTitleTop: {
      type: String,
      default: "23%",
    },
    mainTitleLeft: {
      type: String,
      default: "16%",
    },
    // 副标题1配置
    subTitle: {
      type: String,
    },
    subTitleColor: {
      type: String,
      default: "#000",
    },
    subTitleTop: {
      type: String,
      default: "41%",
    },
    subTitleLeft: {
      type: String,
      default: "16%",
    },
    // 副标题2配置
    subTitle2: {
      type: String,
    },
    subTitle2Color: {
      type: String,
      default: "#000",
    },
    subTitle2Top: {
      type: String,
      default: "56%",
    },
    subTitle2Left: {
      type: String,
      default: "16%",
    },
    // 按钮配置
    btnTop: {
      type: String,
      default: "58%",
    },
    btnLeft: {
      type: String,
      default: "6.5%",
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: false,
      header_icon_btn1: false,
      header_m_active: false,
      myMenuIndex: this.menuIndex,
      isShowBlackLogo: false,
      fixedNav: true,
      productList: [
        {
          title: "e勘察数字服务系统",
          content:
            "将勘察数据采集、数据存储与导出、土工试验任务书编制及下发、土工试验报告提交纳入一体化管理，与后续勘察数据分析、整理与归档形成闭合，提高了勘察技术人员工作效率",
          url: "/ekancha",
        },
        {
          title: "岩土勘察数据分析（YTKC软件）",
          content:
            "进行概预算、工作量统计、土层统计、试验指标统计，计算土层沉降量、单桩承载力、黄土湿陷量、边坡安全系数等",
          url: "/ytkc",
        },
        {
          title: "岩土工程勘察文件自动化系统",
          content:
            "软件链接YTKC数据库，并自动生成GA数据库，用户录入项目工程信息，设置报告目录，即可一键生成勘察报告",
          url: "/automation",
        },
        {
          title: "大西安岩土与地质环境综合信息系统",
          content:
            "大西安地区有据可查的地质数据，并提供展示、提取、查询、研究和管理功能",
          url: "/geology",
        },
      ],
      solutionList: [
        {
          title: "工程行业解决方案",
          content:
            "自动化勘察业务流程，减少人力和时间成本，提高勘察效率，降低企业的勘察成本",
          url: "/gongcheng",
        },
      ],
    };
  },
  methods: {
    mouseleave() {
      if (!this.fixedNav) {
        this.isShowBlackLogo = false;
      }
    },
    mouseover() {
      if (!this.fixedNav) {
        this.isShowBlackLogo = true;
      }
    },
    clickProductItem(link) {
      this.$router.push(link);
    },
    showCont() {
      this.show = !this.show;
      this.header_icon_btn1 = !this.header_icon_btn1;
      this.header_m_active = !this.header_m_active;
    },
  },
};
</script>
<style scoped lang="scss">
* {
  box-sizing: content-box;
}
.headerBox {
  background-repeat: no-repeat;
  background-position: center 0;
  background-size: 100% 100%;
}
.height_100 {
  height: 100%;
}
.header_left {
  width: 100%;
}
.header_left > li {
  float: left;
  text-align: center;
  width: 116px;
}
.header_left .router-link-exact-active.router-link-active {
  color: #409eff !important;
  transition: color 0.3s;
  border-bottom: 1px solid #409eff;
}
.header:hover {
  background-color: #fff;
  transition: all 0.5s;
  border-bottom: 1px solid #dedede;
  .header_left > li > a {
    color: #666;
  }
}
.logo {
  margin-left: -100px;
  margin-right: 40px;
}
.logo > img {
  width: 72px;
  vertical-align: middle;
}
.header_left > li > a {
  display: inline-block;
  font-size: 16px;
  color: #000;
  transform: translate3d(-5px, 0, 0);
  transition: transform 0.5s, color 0.5s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
  width: 116px;
}
.header_left > li > a:hover {
  color: #409eff !important;
  transition: color 0.3s;
}

a {
  color: #fff;
  text-decoration: none;
  /* -webkit-backface-visibility: hidden; */
}
.header {
  width: 100%;
  height: 76px;
  line-height: 76px;
  /* background-color: hsla(0, 0%, 100%, 0.95); */
  //   position: fixed;
  //   top: 0;
  z-index: 999;
}
.header_logo > img {
  width: 100%;
}
.header_m img {
  vertical-align: middle;
  line-height: 1.18rem;
  margin-top: 10px;
}
.header_m > .header_logo {
  float: left;
  margin-left: 1rem;
  width: 3rem;
  height: 100%;
}
.header_m {
  background: #fff;
  height: 2.5rem;
}
.header_m > .header_icon {
  float: right;
  height: 100%;
}
.header_icon_btn {
  margin-top: 0.7rem;
  margin-right: 1.4rem;
  width: 1.52rem;
  height: 100%;
  line-height: 0;
}
.header_icon_btn > span {
  display: inline-block;
  vertical-align: top;
  margin: 0.18rem 0;
  width: 100%;
  height: 2px;
  background-color: #000;
  transition: all 0.5s ease-in-out;
  transform-origin: left center;
}
.header_m_active {
  background: #000;
}
.header_icon_btn1 > span:first-child {
  transform: rotate(45deg);
  background-color: #fff;
}
.header_icon_btn1 > span:nth-last-child(2) {
  opacity: 0;
}
.header_icon_btn1 > span:last-child {
  transform: rotate(-45deg);
  background-color: #fff;
}

.solution-container {
  background-color: #fff;
  position: fixed;
  top: 10px;
  width: 100vw;
  height: 0;
  display: flex;
  flex-wrap: wrap;
  z-index: 99;
  padding-bottom: 0px;
  box-shadow: 0 2px 4px -3px #dedede;
  left: 0;
  overflow: hidden;
  &-item {
    width: 33%;
    background: #fff;
    :first-child {
      color: #000;
      margin-top: 30px;
      text-align: left;
      padding-left: 60px;
      font-size: 16px;
      cursor: pointer;
      line-height: 30px;
      font-weight: 600;
    }
    :first-child:hover {
      color: #409eff;
      transition: color 0.3s;
    }
    :last-child {
      color: #666;
      margin-top: 10px;
      text-align: left;
      padding-left: 60px;
      font-size: 14px;
      line-height: 30px;
    }
  }
}
.solution-container:hover {
  height: 240px;
  padding-bottom: 40px;
  .header {
    background-color: #fff !important;
  }
}
.solution-menu:hover + .solution-container {
  height: 240px;
  padding-bottom: 40px;
  transition: all 0.5s;
}
.header-fixed {
  background-color: #fff;
  border-bottom: 1px solid #dedede;
  li > a {
    color: #000;
  }
}
</style>
<style>
.el-dropdown {
  font-size: 16px;
  color: #fff;
}

.banner {
  width: 100%;
  height: 500px;
}
.banner .banner_con {
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.banner .banner_con p:nth-child(1) {
  font-size: 52px;
  color: #000;
  text-align: justify;
  margin-bottom: 24px;
  position: absolute;
  font-weight: 600;
  top: 23%;
  left: 16%;
}
.banner .banner_con p:nth-child(2) {
  font-size: 30px;
  color: #000;
  text-align: justify;
  margin-bottom: 24px;
  position: absolute;
  top: 41%;
  left: 16%;
}
.banner .banner_con p:nth-child(3) {
  font-size: 18px;
  color: #000;
  text-align: justify;
  margin-bottom: 24px;
  position: absolute;
  top: 58%;
  left: 16%;
}
.banner .banner_con .btn {
  display: inline-block;
  margin-top: 70px;
  border-radius: 20px;
  width: 178px;
  height: 40px;
  margin-right: 30px;
  color: white;
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  background-image: linear-gradient(135deg, #1cffcd 0%, #2347ff 100%);
  margin-left: 180px;
  position: absolute;
  top: 58%;
  left: 16%;
  transition: all 0.3s;
}
.banner .banner_con .btn:hover {
  background-image: linear-gradient(135deg, #00ffc8 0%, #002aff 100%);
}
</style>
